import { Level } from "src/app/modals/stock-levels-model/stock-levels-modal.component";
import { SkuGroups } from "./History";

export enum CrateStateEnum {
  STORED = 'STORED',
  STORED_DIVERGENT = 'STORED_DIVERGENT',
  WRONG_POSITION = 'WRONG_POSITION',
  RECEIVED = 'RECEIVED',
  AWAITING_STORAGE = 'AWAITING_STORAGE',
  AWAITING_PICKING = 'AWAITING_PICKING',
  AWAITING_MOVING = 'AWAITING_MOVING',
  MOVING = 'MOVING',
  MISPLACED = 'MISPLACED',
  MISPLACED_DIVERGENT = 'MISPLACED_DIVERGENT',
  MISSING = 'MISSING',
  RESERVED = 'RESERVED',
  FOUND_MISPLACED = 'FOUND_MISPLACED',
  FOUND = 'FOUND',
  STORED_AT_EXIT = "STORED_AT_EXIT",
  AWAITING_EXPEDITION = "AWAITING_EXPEDITION",
  READY_TO_DISPATCH = "READY_TO_DISPATCH",
  MISPLACED_EXPEDITION = "MISPLACED_EXPEDITION"
}

export function translateState(state: CrateStateEnum) {
  switch (state) {
    case CrateStateEnum.STORED:
    case CrateStateEnum.STORED_AT_EXIT:
      return 'Armazenado';
    case CrateStateEnum.STORED_DIVERGENT:
      return 'Armazenado e divergente';
    case CrateStateEnum.WRONG_POSITION:
      return 'Posição errada';
    case CrateStateEnum.RECEIVED:
      return 'Recebido';
    case CrateStateEnum.AWAITING_STORAGE:
      return 'Aguardando armazenamento';
    case CrateStateEnum.AWAITING_PICKING:
      return 'Aguardando separação';
    case CrateStateEnum.AWAITING_MOVING:
      return 'Aguardando movimentação';
    case CrateStateEnum.MOVING:
      return 'Movimentando';
    case CrateStateEnum.MISPLACED:
      return 'Deslocado';
    case CrateStateEnum.MISPLACED_DIVERGENT:
      return 'Deslocado e divergente';
    case CrateStateEnum.MISSING:
      return 'Perdido';
    case CrateStateEnum.RESERVED:
      return 'Reservado';
    case CrateStateEnum.FOUND_MISPLACED:
      return 'Encontrado em lugar indevido';
    case CrateStateEnum.FOUND:
      return 'Encontrado';
    default:
      return '---';
  }
}

export interface ICrateMap {
  id: string;
  x: number;
  y: number;
  z: number;
  levelName?: string;
  allLevels?: Level[];
  skuGroups: {
    sku: string;
    name: string;
    quantity: number;
    packSize: number;
  }[];
}

export interface ICrate {
  description: string;
  id: string;
  quantity: number;
  sku: string;
  tagRfid: string;
}

export interface MissingCrate {
  receivedAt: number;
  updatedAt: number;
  lastMovedAt: number;
  id: string;
  tagRfid: string;
  skuGroups: {
    packSize: number;
    quantity: number;
    sku: string;
    name: string;
  }[];
  state: string;
  type: string;
  x: number;
  y: number;
  z: number;
  position?: string;
  alias?: string;
  groundPositionGroupId?: string;
  groundPositionId: string;
  section?: string;
  selected?: boolean;
  activeInventoryCount: number;
  inventoryCount: number;
}

export interface Crate {
  id: string;
  tagRfid: string | null;
  state: string;
  type: string;
  x: number;
  y: number;
  z: number;
  position: string;
  tenantId: string;
  createdAt: number;
  updatedAt: number;
  skuGroups: SkuGroups[];
  commentsQty: number;
  section: string;
  levelName: string;
  alias: string;
  lastMovedAt: number;
  palletStatus?: string;
  invoices?: any[];
  parents?: Crate[];
  children?: Crate[];
  cratesUnderAlert?: CrateUnderAlert[];
}

export interface CrateUnderAlert {
  id: string;
  crateId: string;
  tenantId: string;
  userId: string;
  createdAt: number;
  updatedAt: number;
}

export enum CrateType {
  PALLET = "PALLET",
  REMAINS = "REMAINS",
}
